<template>
  <div class="out">
    <banner />
    <div class="stickybar">
      <a :style="nowindex===1 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">产品简介</a>
      <a :style="nowindex===2 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">功能介绍</a>
      <a :style="nowindex===3 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">产品优点</a>
      <a :style="nowindex===4 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功案例</a>
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text">
          <h3
            style="font-weight: bolder;color: rgb(37, 108, 255);">云大数据简介</h3>
          <p class="big_des"><br>以大数据为使命，积极运用云数据提供一站式开发、分析及应用平台支持，助力企业在大数据时代更敏捷、更智能、更具
          洞察力。</p>
        </div>
      </div>
    </div>

    <div id="parttwo" ref="partii" class="function-wrap wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
      <div class="function-box">
        <p class="h1">云大数据功能介绍</p>
        <ul class="function-content">
          <li v-for="(item, index) in functionArr" :key="index">
            <i :class="`function-${index+1}`"/>
            <p class="title1">{{ item.title }}</p>
            <p class="detail">
              {{ item.desc }}<br >
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div id="partthree" ref="partiii" class="function-wrap" data-wow-duration="1s" data-wow-delay="0s">
      <div class="function-box">
        <p class="h1">阳光村务优点</p>
        <ul class="function-content">
          <li v-for="(item, index) in functionArr2" :key="index">
            <i :class="`function-${index+4}`"/>
            <p class="title1">{{ item.title }}</p>
            <p class="detail">
              {{ item.desc }}<br >
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div id="partfour">
      <cs-btm :show="false" title="苏州市吴中区农业农村局：“三资系统”云数据中心正式上线" desc="2020年12月30日，吴中区农村集体“三资”云数据中心正式上线，该中心充分利用大数据监督和区块链科技优势，打通信息孤岛，将市交易系统、区集体资产管理系统、村级资金监管平台、财务记账系统和阳光村务平台进行贯通，确保所有村(社区)集体经济组织资金收支按照规范流程开展审批业务，并按照统一设置的会计科目进行财务核算，集体资产租金收缴和银行资金流水全面关联，实现集体资金“全留痕线上审批+全过程线上结算+全方位线上监管”，从源头上杜绝集体资产“体外循环”、集体资金“截留挪用”情况的发生。" />
      <div slot="img" class="bigdata_img">
        <img src="@/assets/bigdata22.jpg" >
        <img src="@/assets/bigdata11.jpg" >
      </div>
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import CsBtm from './CsBtm.vue'
import Banner from '@/views/products/components/Banner'
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Sunshine',
  components: { CsBtm, Banner, CircleBtn },
  data() {
    return {
      nowindex: 1,
      functionArr: [
        { title: '监测中心', desc: '高效率，多维度的实时监测各个模块的核心数据' },
        { title: '预警中心', desc: '睿泽通过信息技术建立监督模型，通过数据分析运算，对上链数据进行交叉验证，实现对违规问题的快速捕捉、自动预警。' },
        { title: '监督中心', desc: '纪委借助监督中心对超出预警值以外的数据进行监管，构建“规范、快捷、严谨、求实、协作"的监督平台' }
      ],
      functionArr2: [
        { title: '可靠、安全的数据存储', desc: '云计算提供了最为可靠安全的数据存储中心，数据将会自动同步，云计算通过严格的权限管理策略支持数据的共享' },
        { title: '方便、快捷、高效', desc: '用户不需要安装和升级电脑上的各种应用软件，也不需要人工计算，全部自动直观的通过云服务计算' },
        { title: '图表丰富，炫酷大屏', desc: '收支明细、合同金额、各项补贴等费用公布' }
      ]
    }
  },
  methods: {
    jump: function(x) {
      this.nowindex = x
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
.bigdata_img {
  display: flex;
  justify-content: space-around;
  padding-bottom: 60px;
  margin-top: -30px;
}
.bigdata_img img{
  width: 400px;
}
.title {
  /* width: 1200px; */
  text-align: center;
  margin: 0 auto;
}

.top-text {
  padding: 5.5% 0 4% 0;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}
.stickybar a {
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
li {
  list-style-type: none;
}
.function-wrap {
  width: 100%;
  /* height: 890px; */
  position: relative;
  /* background: url(../assets/function_bg.jpg) 50% 50% no-repeat; */
  background-size: cover;
  /* -ms-behavior: url(css/backgroundsize.min.htc);
  behavior: url(css/backgroundsize.min.htc); */
}
.function-box {
  /* width: 1210px; */
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.function-box > p.h1 {
  font-size: 32px;
  color: #333;
  text-align: center;
  line-height: 1;
  padding: 70px 0 ;
}
.function-content {
  width: 100%;
  position: relative;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
}
.function-content li {
  position: relative;
  width: 33%;
  /* width: 350px;
  height: 250px;
  float: left;
  margin-left: 40px; */
  background: #fff;
  border-radius: 5px;
  margin-bottom: 70px;

}
.function-content li:first-child,
.function-content li:first-child + li + li + li {
  margin-left: 0px;
}
.function-content li:first-child + li + li + li + li + li + li {
  margin-left: 0px;
}
.function-content li p.title1 {
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #292929;
  margin: 20px 0;
  /* padding: 100px 0 30px; */
}
.function-content li p.detail {
  text-align: center;
  line-height: 180%;
  font-size: 14px;
  color: #7f7f7f;
}
.function-content li i {
  display: block;
  width: 193px;
  height: 176px;
  margin: 0 auto;
  zoom: 0.8;
  /* position: absolute;
  left: 50%;
  margin-left: -50px;
  top: -50px; */
  border: solid 1px #BBBBBB;
  border-radius: 100%;
}
.function-content li i.function-1 {
  color: rgba(225, 93, 93, 100);
  background: url('~@/assets/bigdata1.svg')  no-repeat 50% 50%;
}
.function-content li i.function-2 {
  background: url('~@/assets/bigdata2.svg') no-repeat 50% 50%;
}
.function-content li i.function-3 {
  background: url('~@/assets/bigdata3.svg') no-repeat 50% 50%;
}
.function-content li i.function-4 {
  background: url('~@/assets/bigdata4.svg') no-repeat 50% 50%;
}
.function-content li i.function-5 {
  background: url('~@/assets/bigdata5.svg') no-repeat 50% 50%;
}
.function-content li i.function-6 {
  background: url('~@/assets/bigdata6.svg') no-repeat 50% 50%;
}

.gc_ceng.gc_ceng_four {
    padding: 70px 0 70px 0;
    background: #fff;
    background: url(~@/assets/products-bg.714f810.png)
}

.gc_ceng .ceng_thin {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    text-align: left;
}

.gc_ceng .ceng_thin .ceng_title {
    font-size: 32px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 40px;
    margin: 0 0 20px;
    text-align: center;
}

.customer_success {
  width: 100%;
  height: 400px;
  margin: 0 auto;
  padding-top: 85px;
  padding-bottom: 90px;
}
.customer_iframe {
  display: flex;
  margin-top: -20px;
  padding-bottom: 20px;
  justify-content: space-around;
}
p:nth-child(1) {
    margin: auto;
    width: auto;
    height: auto;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(6,24,40,1);
}
h4 {
  margin: 20px 0 10px
}
.wuzhong_desc {
    margin: auto;
    margin-top: 20px;
    width: 1000px;
    height: auto;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(13,10,38,1);
    line-height: 24px;
    text-align: center;
}
.customer_success-box {
  max-width: 1200px;
  margin: 50px auto 0 auto;

}
.customer_success-box  img {
  width: 90%;
  margin: 0 auto;
  border: solid
}
.gc_ceng .ceng_thin .ceng_decro {
    font-size: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #666;
    line-height: 15px;
    margin: 0 0 70px;
    text-align: center;
}

.gc_ceng.gc_ceng_four .ceng_box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.gc_ceng.gc_ceng_four .ceng_box>div {
    -webkit-box-flex: 0;
    flex: 0 0 280px;
    margin: 0 0 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.gc_ceng.gc_ceng_four .ceng_box>div>div {
    width: 180px;
    height: 180px;
    margin: 0 auto;
    background: #fff;
    -webkit-box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    border-radius: 50%;
    margin-bottom: 20px;
}

.gc_ceng.gc_ceng_four .ceng_box>div>p {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 34px;
}
.gc_ceng.gc_ceng_four .ceng_box>div>div>img {
    /* max-width: 100%; */
    max-height: 100%;
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    zoom: 0.7;
}

#partfour {
  background: rgba(234,239,243,1);
}

.practice h1{
  padding: 50px 0 50px 0;
}

.practice img {
  padding: 50px 0 50px 0;
}

#solutiontext {
  color:whitesmoke;
  padding-bottom: 30px;
}

.solutionList {
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  background-color: #000413;
}

.solutionContent {
  display: flex;
  padding-top: 30px;
}

.solutionList h4 {
  margin: 0;
}

.leftList {
  width: 400px;
}

.listItem {
  padding: 20px 100px 20px 100px;
  background-color: #000413;
}

.leftItem p{
  color: whitesmoke;
  text-align: left;
  padding: 2%;
}

.leftItem {
  display: flex;
  margin:5px;
  padding:3px;
  background: linear-gradient(to right,rgba(64, 224, 208, 1), rgba(64, 224, 208, 0));
}

.shop-dashboard-homepage {
  width: 325px;
  margin-top: 20px;
  /* margin-left: 50px; */
}
.shop-dashboard-homepage__header {
  height: 65px;
  /* width: 325px; */
  background-image: url(~@/assets/mobile_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  border: 1px solid #e5e5e5;
  border-bottom: 0;
}
.shop-dashboard-homepage__title {
  display: inline-block;
  padding: 23px 40px 0 60px;
  height: 55px;
  line-height: 31px;
  width: 100%;
  box-sizing: border-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
  color: #111;
}
.shop-dashboard-homepage__iframe {
  border: 1px solid #e5e5e5;
  border-top: 0;
}

.preview_btn {
  position: absolute;
  right: 30px;
  top: 500px;
}

/* .rightContent {
  background: url(../assets/solution3-1.97f0170.png);
  width:780px;
  height: 600px;
  margin: auto;
}

.rightContent p {
  color:whitesmoke;
  text-align:left;
} */

#review2 {
  background: url(../assets/solution-bg.2000a70.png) no-repeat 50%;
}

#myh2 {
  background: url(../assets/sqc.png) no-repeat 50% 50%
}

.jn_lisyc li {
    width: 48%;
    float: left;
    margin-right: 4%;
    margin-bottom: 16px;
    height: 114px;
}

.jn_lisyc li:nth-of-type(2n) {
    margin-right: 0;
}

.jn_lisyc {
    overflow: hidden;
}

.fl {
    float: left;
}

.content {
    width: 400px;
    margin-left: 48px;
}

dd {
    margin-bottom: .5rem;
    margin-left: 0;
}

.content dd {
    font-size: 22px;
    color: #333333;
}

.rikc {
    margin: 50px auto;
}
</style>>



// WEBPACK FOOTER //
// src/components/bigdata.vue